<template>
  <input :id="idBtn" name="choice" type="radio" class="radio" :value="value" @click="setAnswer()" v-if="type=='radio'" :checked="checked">
  <input :id="idBtn" name="choice" type="checkbox" v-else :value="value" v-model="valueCheckBox"/>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: "RadioButton",
    props: ['value', 'idBtn', 'type', 'checked'],
    data: () => {
      return {
        inputActive: false,
      }
    },
    computed: {
      ...mapGetters({
        answerSelected: 'getAnswerSelected'
      }),
      valueCheckBox: {
        get: function(val) {
          return this.checked
        },
        set: function(checked) {
          let answers = this.answerSelected

          if (!answers || answers === 'false') {
            answers = []
          }

          if (checked) {
            answers.push(this.idBtn);
          } else {
            answers = answers.filter(el => el != this.idBtn)
          }

          this.setAnswerSelected(answers)
        }
      },
      imgPath() {
        if (this.answer.node.imageUrl) {
          if (this.answer.node.imageUrl.startsWith('http') || this.answer.node.imageUrl.startsWith('//')) {
            return this.answer.node.imageUrl;
          } else {
            return process.env.VUE_APP_URL_UPLOADS + this.answer.node.imageUrl;
          }
        } else {
          return '';
        }
      },
    },
    methods: {
      ...mapActions({
        setAnswerSelected: 'setAnswerSelected'
      }),
      setAnswer() {
        this.setAnswerSelected(this.value)
      },
    }
  }
</script>

<style lang="scss">

    /* input type radio */

    [type="radio"]:checked,
    [type="radio"]:not(:checked) {
      position: absolute;
      left: -9999px;
    }

    [type="radio"]:checked + .label .description,
    [type="radio"]:not(:checked) + .label .description {
      position: relative;
      padding-left: rem(40px);
      cursor: pointer;
      line-height: rem(25px);
      display: inline-block;
      color: #666;
    }

    [type="radio"]:checked + .label .description:before,
    [type="radio"]:not(:checked) + .label .description:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: rem(24px);
      height: rem(24px);
      border: 1px solid #9B9B9B;
      border-radius: 100%;
      background: #fff;
    }

    [type="radio"]:checked + .label .description:after,
    [type="radio"]:not(:checked) + .label .description:after {
      content: '';
      width: rem(12px);
      height: rem(12px);
      background-color: color(blue);
      border: 1px solid color(blue);
      position: absolute;
      top: rem(6px);
      left: rem(6px);
      border-radius: 100%;
      -webkit-transition: all 0.2s ease;
      transition: all 0.2s ease;
    }

    [type="radio"]:checked + .label .description:before {
      border: 1px solid color(blue);
    }

    [type="radio"]:not(:checked) + .label .description:after {
      opacity: 0;
      -webkit-transform: scale(0);
      transform: scale(0);
    }

    [type="radio"]:checked + .label .description:after {
      opacity: 1;
      -webkit-transform: scale(1);
      transform: scale(1);
    }

    /* input type checkbox */

    [type="checkbox"]:not(:checked),
    [type="checkbox"]:checked {
      position: absolute;
      left: rem(-9999px);
    }

    [type="checkbox"]:not(:checked) + .label .description,
    [type="checkbox"]:checked + .label .description {
      position: relative;
      padding-left: rem(35px);
      cursor: pointer;
    }

    [type="checkbox"]:not(:checked) + .label .description:before,
    [type="checkbox"]:checked + .label .description:before {
      content: '';
      position: absolute;
      left:0;
      top: 0;
      width: rem(20px);
      height: rem(20px);
      border: 1px solid #9B9B9B;
      background: white;
    }

    [type="checkbox"]:not(:checked) + .label .description:after,
    [type="checkbox"]:checked + .label .description:after {
      content: '✔';
      position: absolute;
      top: -3px;
      left: 3px;
      font-size: rem(17px);
      color: color(blue);
      transition: all .2s;
    }

    [type="checkbox"]:not(:checked) + .label .description:after {
      opacity: 0;
      transform: scale(0);
    }

    [type="checkbox"]:checked + .label .description:after {
      opacity: 1; /* coche opaque */
      transform: scale(1);
    }

    /* input type number / input type text */

    [type="number"], [type="text"] {
      border: 1px solid color(border);
      border-radius: 3px;
      background-color: color(grey);
      min-height: rem(40px);
      width: rem(100px);
      margin-right: rem(15px);
      padding-left: rem(10px);

      @include mq($until: MD) {
        margin: rem(10px) 0 0 0;
      }
    }

    [type="range"] {
      -webkit-appearance: none;
      border-radius: 5px;
      width: rem(100px);
      height: 10px;
      border: 1px solid color(border);
      background-color: color(grey);
      outline: none;
      opacity: 0.7;
      padding: 0;

      &:hover {
        opacity: 1;
      }

      &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: rem(15px);
        height: rem(15px);
        border-radius: 50%;
        background: color(blue);
        cursor: pointer;
      }

      &::-moz-range-thumb {
        width: rem(15px);
        height: rem(15px);
        border-radius: 50%;
        background: color(blue);
        cursor: pointer;
      }

      @include mq($until: MD) {
        margin: rem(10px) 0 0 0;
      }
    }

    input[type="range"]::-ms-fill-lower,
    input[type="range"]::-ms-fill-upper {
      background: transparent!important;
    }
    input[type="range"]::-ms-track {
      border-radius: 8px;
      border: none!important;
      background-color: transparent!important;
    }
    input[type="range"]::-ms-thumb {
      background-color: color(blue);
      border: 1px solid #bdc3c7;
      width: 20px;
      border-radius: 10px;
      cursor: pointer;
    }

    #value {
      text-align: center;
      background: transparent;
      border: 0;
    }

</style>